<template>
  <div
    class="dark:block bg-none p-px dark:bg-[image:var(--border-case-studies-cards)] rounded-xl h-full"
  >
    <div
      class="text-left flex items-start gap-4 p-5 bg-white dark:bg-[var(--bg-case-studies-cards)] rounded-xl shadow-[0_0_0_1px_#E4E2ED] hover:[box-shadow:0_.0625rem_.75rem_0_rgba(38,57,82,.2)] [box-shadow:0_.3em_.3em_-.3em_hsla(0,0%,4%,.1),_0_0_0_.1rem_hsla(0,0%,4%,.08)] transition-all duration-500 h-full"
    >
      <NuxtImg
        :src="img"
        :alt="title"
        width="32"
        height="32"
        class="[filter:drop-shadow(2px_2px_1px_rgba(0,0,0,0.1))] shrink-0"
        v-if="img"
        loading="lazy"
        format="webp"
      />
      <div>
        <h3 class="font-bold text-lg mb-1" v-html="title" />
        <p
          class="text-sm tracking-[0.5px] !leading-[1.8]"
          v-html="description"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  img: String,
  title: String,
  description: String,
});
</script>
